import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, IProtocoloFicDigitalState } from './types';

export const INITIAL_STATE: IProtocoloFicDigitalState = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): IProtocoloFicDigitalState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.PROTOCOLO_FIC_DIGITAL_REQUEST: {
				break;
			}
			case Types.PROTOCOLO_FIC_DIGITAL_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload;
				break;
			}
			case Types.PROTOCOLO_FIC_DIGITAL_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.PROTOCOLO_FIC_DIGITAL_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
